"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Institutions = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _basis = require("basis");

var _reactRouterDom = require("react-router-dom");

var _components = require("../components");

var _hooks = require("../hooks");

var _types = require("../types");

var _actions = require("../context/actions");

var _styled = _interopRequireDefault(require("../theme/styled"));

var _institutions = require("../constants/institutions");

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var LoadingWrapper = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  min-height: 200px;\n"])));

var s = {
  LoadingWrapper: LoadingWrapper
};

var Institutions = function Institutions() {
  var history = (0, _reactRouterDom.useHistory)();
  var dispatch = (0, _hooks.useContextSelector)(function (ctx) {
    return ctx.dispatch;
  });
  var trackEvent = (0, _hooks.useEventTracker)();

  var _useInstitutions = (0, _hooks.useInstitutions)(),
      data = _useInstitutions.data,
      error = _useInstitutions.error;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      institutionsFormData = _useState2[0],
      setInstitutionsFormData = _useState2[1];

  (0, _react.useEffect)(function () {
    if (data) {
      var institutions = data.institutions;
      var transformedData = institutions.reduce(function (acc, item) {
        var updated = _objectSpread({}, acc);

        if (item.slug === _institutions.KIWI_BANK_SLUG) {
          var renamedKiwiBank = _objectSpread(_objectSpread({}, item), {}, {
            name: _institutions.KIWI_BANK_CORRECT_NAME
          });

          renamedKiwiBank.display ? updated.primary.push(renamedKiwiBank) : updated.secondary.push(renamedKiwiBank);
        } else {
          item.display ? updated.primary.push(item) : updated.secondary.push(item);
        }

        return updated;
      }, {
        primary: [],
        secondary: []
      });
      setInstitutionsFormData(transformedData);
    }
  }, [data]);

  var handleSelectInstitution = function handleSelectInstitution(slug) {
    if (!data) {
      return;
    }

    var institution = data.institutions.find(function (item) {
      return item.slug === slug;
    });

    if (!institution) {
      return;
    }

    dispatch((0, _actions.setInstitution)(institution));
    trackEvent({
      action: 'poi-bank-select',
      label: 'institutions.buttonSubmit'
    }, {
      bankSelected: institution.slug
    });
    history.push(_types.Routes.login);
  };

  return /*#__PURE__*/_react.default.createElement(_basis.Container, null, /*#__PURE__*/_react.default.createElement(_components.Header, {
    textPath: "institutions.textIntro",
    error: error === null || error === void 0 ? void 0 : error.error,
    showSecureMessage: true
  }, /*#__PURE__*/_react.default.createElement(_components.TextContent, {
    path: "institutions.textTitle"
  })), !error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !institutionsFormData ? /*#__PURE__*/_react.default.createElement(s.LoadingWrapper, null, /*#__PURE__*/_react.default.createElement(_components.Loading, {
    text: /*#__PURE__*/_react.default.createElement(_components.TextContent, {
      path: "institutions.textLoading"
    })
  })) : /*#__PURE__*/_react.default.createElement(_components.InstitutionsForm, {
    data: institutionsFormData,
    onSelectInstitution: handleSelectInstitution
  })));
};

exports.Institutions = Institutions;